import React from 'react';
import { Target } from '../../models/target';
import { TargetTypesEnum } from '../../models/target-type';
import { getReauthoriseOauthAccountParams } from '../../utils';
import { ReAuthoriseNodeConfirmation } from '../../../../connector/components/ReAuthoriseNodeConfirmation';
import { useReAuthoriseNode } from '../../../../connector/hooks/useReAuthoriseNode';
import { HdButton, HdIcon } from '../../../../components';

export function ObjectExplorerTargetReauth({
  target
}: {
  target: Target
}) {
  const {
    reAuthorise,
    reAuthoriseNodeConfirmationData,
    onReAuthoriseNodeConfirmationClose
  } = useReAuthoriseNode();

  return (
    <div className='no-item-box errored'>
      <div className='no-item-box-icon-container'>
        <HdIcon name='error-filled' className='no-item-box-icon'/>
      </div>

      <p className='no-item-box-title'>
        Reauthorize your Target Account 👆🏻
      </p>

      <div className='no-item-box-desc'>
        You need to reauthorize your {target.targetTypeDisplay} account to proceed.
      </div>

      {target.targetType !== TargetTypesEnum.HUBSPOT ? (
        <HdButton
          dataId='target-object-explorer-reauth'
          className='no-item-box-action'
          onClick={() => reAuthorise({
            ...getReauthoriseOauthAccountParams(target)
          })}
        >
          Reauthorize
        </HdButton>
      ) : null}

      <ReAuthoriseNodeConfirmation
        data={reAuthoriseNodeConfirmationData}
        onClose={onReAuthoriseNodeConfirmationClose}
      />
    </div>
  );
}
